import request from '@/utils/request'
//查询所有商户
export function queryAllShop(data){
  return request({ url: '/shop/query', method: 'post', data })
}
// 品类
export function getCategoryList(data) {
  return request({
    url: '/product/cate/query',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/query.js